/**
 * GA4 Analytics Provider
 *
 * Supports two delivery mechanisms in priority order:
 *   1. window.dataLayer  — GTM (the site's current setup)
 *   2. window.gtag       — direct GA4 snippet
 *
 * Always clears the previous ecommerce object before pushing a new event,
 * which is required by GA4 / GTM to avoid data bleeding between hits.
 */

/**
 * Internal dependencies
 */
import type { AnalyticsProvider } from "../types";

export class Ga4Provider implements AnalyticsProvider {
	track(event: string, params: Record<string, unknown>): void {
		if (globalThis.window === undefined) {
			return;
		}

		if (Array.isArray(globalThis.dataLayer)) {
			globalThis.dataLayer.push(
				{ ecommerce: null },
				{ event, ecommerce: params },
			);
		} else if (typeof globalThis.gtag === "function") {
			globalThis.gtag("event", event, params);
		}
	}
}
